




















































































































import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import TaskApi from '@/api/task'
import AreaApi from '@/api/area'
import { checkCarNo, debounce } from '@/utils/util'
import firstVisit from './firstVisit.vue'
import resurvey from './resurvey.vue'
import motion from './motion.vue'
import NewMotion from './NewMotion.vue'
import LivingPlace from '@/views/investigate/LivingPlace.vue'
import WorkPlace from '@/views/investigate/WorkPlace.vue'
import otherInvestigate from '@/views/other/otherInvestigate.vue'
import PureMediate from '@/views/mediate/LivingPlace.vue'
import manualCard from './manualCard.vue'
import liaisonCard from './liaisonCard.vue'
import {
	TASKTYPE_MAP,
	tasktypeAuthList,
	insuranceTypeAuthList,
} from './authConfig'
let id: any = 0

const debounceSearch = debounce(300)

@Component({
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
		firstVisit,
		resurvey,
		motion,
		NewMotion,
		LivingPlace,
		WorkPlace,
		otherInvestigate,
		PureMediate,
		manualCard,
		liaisonCard,
	},
})
export default class addTaskStep2 extends Vue {
	private addForm: any = {}
	private searchHospital: any = []
	private localSearch: any = ''
	private fetching: boolean = false
	private sameWithPublisher: boolean = false
	private areaName: string = ''
	private resurvey: boolean = false
	private active: any = '1'
	private TASKTYPE_MAP: any = TASKTYPE_MAP

	@Prop()
	private data!: any

	@Prop()
	private toDetailOnOk!: boolean

	@Prop()
	private detailPath!: string

	@Prop()
	private replaceRoute!: string

	@Prop()
	private param!: any

	@Prop()
	private resurveyOrder!: any

	@Prop()
	private visible!: boolean

	@Prop()
	private parentOrderId!: any

	@Watch('resurveyOrder', { immediate: true })
	private onResurveyOrderChange() {
		if (this.resurveyOrder) {
			this.active = this.tabList[0] && this.tabList[0].taskType
		}
	}

	@Watch('active')
	private onActiveChange() {
		this.$nextTick(() => {
			this.setTaskRowCenter()
		})
	}

	@Watch('showManualCard')
	private onCarInsuranceChange() {
		this.$nextTick(() => {
			this.setTaskRowCenter()
		})
	}

	@Watch('showLiaisonCard')
	private onShowLiaisonCardChange() {
		this.$nextTick(() => {
			this.setTaskRowCenter()
		})
	}

	private get tabList() {
		let currentInsurance: any = insuranceTypeAuthList.find(
			(item: any) => item.key === this.data.insuranceType
		)
		// 险种权限前缀
		let authPrefix = ''
		if (currentInsurance) {
			authPrefix =
				currentInsurance.authStr && currentInsurance.authStr.split(':')[1]
		} else {
			return []
		}

		if (this.resurveyOrder) {
			// 由详情新建复勘
			// let resurveyArr = [TASKTYPE_MAP.RESURVEY, TASKTYPE_MAP.MOTION]
			let resurveyArr = [
				TASKTYPE_MAP.RESURVEY,
				TASKTYPE_MAP.MOTION,
				TASKTYPE_MAP.NEW_MOTION,
			]
			if (resurveyArr.includes(this.resurveyOrder.wholeProcessType)) {
				resurveyArr = [this.resurveyOrder.wholeProcessType]
			}
			return tasktypeAuthList.filter(
				(item: any) =>
					resurveyArr.includes(item.taskType) &&
					this.$auth(`${authPrefix}:${item.authStr}`)
			)
		} else {
			return tasktypeAuthList.filter((item: any) =>
				this.$auth(`${authPrefix}:${item.authStr}`)
			)
		}
	}

	private onOk() {
		this.$emit('ok')
	}

	private get showManualCard() {
		// 车险 且为初次探视/住院复勘/活动度复勘
		return (
			this.data.insuranceType === '01' &&
			[
				TASKTYPE_MAP.FIRST_VISIT,
				TASKTYPE_MAP.RESURVEY,
				TASKTYPE_MAP.MOTION,
				TASKTYPE_MAP.NEW_MOTION,
			].includes(this.active) &&
			!(this.resurveyOrder && this.resurveyOrder.isWholeProcess)
		)
	}

	private get showLiaisonCard() {
		// 非车险 且为初次探视/住院复勘/活动度复勘/居家探视
		return (
			this.data.insuranceType !== '01' &&
			[
				TASKTYPE_MAP.FIRST_VISIT,
				TASKTYPE_MAP.RESURVEY,
				TASKTYPE_MAP.MOTION,
				TASKTYPE_MAP.NEW_MOTION,
			].includes(this.active) &&
			!(this.resurveyOrder && this.resurveyOrder.isWholeProcess)
		)
	}

	private get isCarInsurance() {
		return this.data.insuranceType === '01'
	}

	private get isResurveyOrder() {
		return !!this.resurveyOrder
	}

	private toggle(i: any) {
		this.active = i
	}

	private prevStep() {
		this.$emit('prevStep')
	}

	private manual2Injured(checked: boolean) {
		this.$emit('manual2Injured', checked)
	}

	private getStyleProperty(el: any, property: string) {
		if (!el) {
			return 0
		}
		const style: any = window.getComputedStyle(el) || el.currentStyle
		return style[property]
	}

	private setTaskRowCenter() {
		const taskRowEl = (this.$refs.taskRow as any).$el
		const labelEl = taskRowEl.querySelector('.ant-form-item-label')
		const stepsEl: any = document.querySelector('.rs-card .steps')
		const btnsEl: any = document.querySelector('.rs-card .btns')
		const tabsEl: any = document.querySelector('.rs-card .tabs')
		const labelWidth: any = this.getStyleProperty(labelEl, 'width')
		const stepsWidth: any = this.getStyleProperty(stepsEl, 'width')
		const addTaskPage = document.querySelector('.add-task-page')
		const addTaskPagePad = this.getStyleProperty(addTaskPage, 'paddingLeft')
		const addTaskPageMargin = this.getStyleProperty(addTaskPage, 'marginLeft')

		if (!(tabsEl && btnsEl)) {
			return
		}

		if (this.showManualCard || this.showLiaisonCard) {
			// reset
			taskRowEl.style.margin = 'auto'
			taskRowEl.style.width = '1100px'

			stepsEl.style.marginLeft = `${parseInt(labelWidth || 0) +
				parseInt(addTaskPagePad) +
				parseInt(addTaskPageMargin)}px`
			btnsEl.style.marginLeft = `${parseInt(labelWidth || 0)}px`
			taskRowEl.style.width = `${((parseInt(stepsWidth) +
				parseInt(labelWidth)) *
				3) /
				2}px`
		} else {
			// reset
			stepsEl.style.margin = 'auto'

			taskRowEl.style.marginLeft = `-${parseInt(labelWidth || 0) / 2}px`
			btnsEl.style.marginLeft = `${parseInt(labelWidth || 0)}px`
			taskRowEl.style.width = `${parseInt(stepsWidth) + parseInt(labelWidth)}px`
		}
	}

	private mounted() {
		this.$nextTick(() => {
			this.setTaskRowCenter()
		})
	}

	private created() {
		this.active = this.tabList[0] && this.tabList[0].taskType
	}

	private activated() {
		window.addEventListener('resize', this.setTaskRowCenter)
	}

	private deactivated() {
		window.removeEventListener('resize', this.setTaskRowCenter)
	}
}
